import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const SUPPORTED_LANGUAGES = {
  english: { code: 'english', name: 'English', nativeName: 'English' },
  hindi: { code: 'hindi', name: 'Hindi', nativeName: 'हिंदी' },
  marwari: { code: 'marwari', name: 'Marwari', nativeName: 'मारवाड़ी' },
};

const STORAGE_KEY = 'qkly_language';
const DEFAULT_LANGUAGE = 'english';

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && SUPPORTED_LANGUAGES[stored] ? stored : DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, currentLanguage);
  }, [currentLanguage]);

  const changeLanguage = (languageCode) => {
    if (SUPPORTED_LANGUAGES[languageCode]) {
      setCurrentLanguage(languageCode);
    }
  };

  const value = {
    currentLanguage,
    changeLanguage,
    languages: SUPPORTED_LANGUAGES,
    isLanguageSupported: (code) => !!SUPPORTED_LANGUAGES[code],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
